import { css, cva } from '@/styled-system/css';

export const comboboxContentRecipe = cva({
  base: {
    borderRadius: 'obj.soft',
    backgroundColor: 'bg.elevated.mediumShadow',
    boxShadow: 'md',
    position: 'relative',
    overflow: 'auto',
    maxHeight: '360px',
    transitionProperty: {
      _motionReduce: 'none',
      _motionSafe: 'opacity, transform',
    },
    transitionDuration: {
      _motionReduce: '0s',
      _motionSafe: '{durations.250}',
    },
    transitionTimingFunction: '{easings.ease}',
  },
  variants: {
    open: {
      true: {
        opacity: 1,
        transform: 'none',
      },
      false: {
        opacity: 0,
        transform: 'scale(0.975)',
      },
    },
    dividers: {
      true: {
        '& .c11n_combobox__group:not(:last-child)': {
          borderBottomWidth: 'default',
          borderBottomStyle: 'solid',
          borderBottomColor: 'Combobox.Group.border',
        },
      },
      false: {},
    },
  },
});

export const comboboxContentPositionerStyles = css.raw({
  zIndex: 'combobox',
});
